import { gql, useQuery } from '@apollo/client';
import type {
  OrgOnboardingPasswordSetQuery,
  OrgOnboardingPasswordSetQueryVariables,
} from '../graphql/generated/graphqlTypes';

const CURRENT_USER_QUERY = gql`
  query orgOnboardingPasswordSet {
    currentSession {
      user {
        id
        passwordUpdatedAt
      }
    }
  }
`;

const useIsPasswordSet = () => {
  const response = useQuery<
    OrgOnboardingPasswordSetQuery,
    OrgOnboardingPasswordSetQueryVariables
  >(CURRENT_USER_QUERY);

  return {
    ...response,
    data:
      !!response.data && !!response.data.currentSession.user.passwordUpdatedAt,
  };
};

export default useIsPasswordSet;
